'use client';

import { useState, useEffect } from 'react';

/**
 * Detects dark/light mode from next-themes (class on <html>).
 *
 * @param {'auto'|'dark'|'light'} variant
 * @returns {boolean} isDark
 */
export function useBackgroundTheme(variant = 'auto') {
  const [isDark, setIsDark] = useState(true); // default dark until DOM is available

  useEffect(() => {
    if (variant !== 'auto') {
      setIsDark(variant === 'dark');
      return;
    }

    const check = () => setIsDark(document.documentElement.classList.contains('dark'));
    check();

    const observer = new MutationObserver(check);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => observer.disconnect();
  }, [variant]);

  return isDark;
}
